module.exports = __webpack_public_path__ + "img/page-404.69f3586e.jpeg";